<div class="parent">
    <div class="child" >
        <p>{{'landing.cokkieMessage' | translate}}</p>
        <button class="buttonAccept" style="margin-right: 100px" mat-button color="accent" (click)="closeCookieNotice(true)">{{'landing.cookiesAccept' | translate}}</button>
        <button class="buttonDecline" mat-button  (click)="closeCookieNotice(false)">{{'landing.cookiesDecline' | translate}}</button>
    </div>
</div>
